import { COMMA_WITH_SPACE, EMPTY_STRING, SQUARE_BRACKETS_REGEXP, UNDERSCORE, ZERO } from '@constants';
import { TranslationContent } from '@customTypes';

export const getItemHeightByTextLength = (data: TranslationContent[], index: number) => {
  const item = data[index];
  if (!item) return 120;

  const textLength = item.translatedText?.toString().length || ZERO;
  if (textLength > 800) return 250;
  if (textLength > 400) return 170;
  if (textLength > 100) return 130;

  return 120;
};

export const getFormFieldKey = (textKey: string, activeTab: number) => {
  const formattedKey = textKey.replace(SQUARE_BRACKETS_REGEXP, EMPTY_STRING);

  return `${activeTab}.${formattedKey.split(COMMA_WITH_SPACE).join(UNDERSCORE)}`;
};
